import React, { useState } from 'react';

const TIENDAS_DEMO = [
  { id:1, nombre:'Lupita Fashions MX', subdominio:'lupita-fashions', propietario:'Lupita Hernández', email:'lupita@gmail.com', tel:'+52 33 1111 2222', plan:'pro',    estado:'bloqueado', ventas:24360, pedidos:47, proximoPago:'Vencido',       creado:'01 Ene 2026' },
  { id:2, nombre:'Botas García',        subdominio:'botas-garcia',    propietario:'Carlos García',    email:'carlos@gmail.com', tel:'+52 33 3333 4444', plan:'basico', estado:'activo',    ventas:10080, pedidos:23, proximoPago:'15 May 2026',    creado:'10 Feb 2026' },
  { id:3, nombre:'Ropa Sofía',          subdominio:'ropa-sofia',      propietario:'Sofía Ramírez',    email:'sofia@gmail.com',  tel:'+52 33 5555 6666', plan:'basico', estado:'activo',    ventas:7830,  pedidos:18, proximoPago:'22 May 2026',    creado:'15 Feb 2026' },
  { id:4, nombre:'Modas Caro',          subdominio:'modas-caro',      propietario:'Carolina López',   email:'caro@gmail.com',   tel:'+52 33 7777 8888', plan:'gratis', estado:'bloqueado', ventas:1240,  pedidos:5,  proximoPago:'Vencido',        creado:'01 Mar 2026' },
  { id:5, nombre:'Joyería Luna',        subdominio:'joyeria-luna',    propietario:'Ana Luna',         email:'ana@gmail.com',    tel:'+52 33 9999 0000', plan:'pro',    estado:'prueba',    ventas:3200,  pedidos:12, proximoPago:'Prueba 5 días',  creado:'05 May 2026' },
];

// Planes del sistema — en producción vendrán del API
const PLANES_SISTEMA = [
  { id:'gratis', nombre:'Gratis',  precio:0,   comision:0 },
  { id:'basico', nombre:'Básico',  precio:199, comision:3 },
  { id:'pro',    nombre:'Pro',     precio:599, comision:2 },
];

const PLAN_BADGE = {
  gratis: { bg:'#F0F4F0', color:'#7A8F89', label:'Gratis' },
  basico: { bg:'#E6F1FB', color:'#042C53', label:'Básico' },
  pro:    { bg:'#EEEDFE', color:'#26215C', label:'Pro' },
};

const ESTADO_BADGE = {
  activo:    { bg:'#E1F5EE', color:'#085041', label:'Activo' },
  bloqueado: { bg:'#FCEBEB', color:'#501313', label:'Bloqueado' },
  prueba:    { bg:'#FFF3E0', color:'#E65100', label:'Prueba' },
};

const S = {
  topbar:     { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 },
  h1:         { fontSize:20, fontWeight:700, color:'#0D1F1A' },
  filtros:    { display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' },
  sel:        { padding:'7px 12px', borderRadius:8, border:'1px solid #E4EDE8', background:'white', fontSize:12, color:'#0D1F1A', cursor:'pointer', fontFamily:'inherit' },
  inputBusq:  { padding:'7px 12px', borderRadius:8, border:'1px solid #E4EDE8', background:'white', fontSize:12, color:'#0D1F1A', outline:'none', fontFamily:'inherit', width:220 },
  card:       { background:'white', borderRadius:12, border:'1px solid #E4EDE8', marginBottom:12, overflow:'hidden' },
  table:      { width:'100%', borderCollapse:'collapse', fontSize:12 },
  th:         { padding:'9px 12px', textAlign:'left', fontSize:11, fontWeight:700, color:'#7A8F89', borderBottom:'1px solid #E4EDE8', background:'#F0F4F0' },
  td:         { padding:'10px 12px', borderBottom:'1px solid #E4EDE8', color:'#0D1F1A', verticalAlign:'middle' },
  badge:      { display:'inline-block', padding:'2px 8px', borderRadius:20, fontSize:11, fontWeight:600 },
  subdom:     { fontSize:11, color:'#7A8F89' },
  subdomSpan: { color:'#075E54', fontWeight:600 },
  btn:        { fontSize:11, padding:'4px 8px', borderRadius:8, border:'1px solid #E4EDE8', background:'none', color:'#7A8F89', cursor:'pointer', fontFamily:'inherit', marginRight:4 },
  btnOk:      { color:'#085041', borderColor:'#5DCAA5' },
  btnRojo:    { color:'#A32D2D', borderColor:'#F09595' },
  btnVer:     { color:'#042C53', borderColor:'#90caf9' },
  btnEdit:    { color:'#075E54', borderColor:'#c8e6c9' },
  overlay:    { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' },
  modal:      { background:'white', borderRadius:16, padding:24, width:500, maxHeight:'90vh', overflowY:'auto' },
  mTitle:     { fontSize:16, fontWeight:800, color:'#0D1F1A', marginBottom:20 },
  mGrid:      { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 },
  mField:     { marginBottom:12 },
  mLbl:       { fontSize:11, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:4, display:'block' },
  mVal:       { fontSize:13, color:'#0D1F1A', fontWeight:500 },
  mInput:     { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, padding:'9px 12px', fontSize:13, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box' },
  mSelect:    { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, padding:'9px 12px', fontSize:13, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box', cursor:'pointer' },
  divider:    { height:1, background:'#E4EDE8', margin:'14px 0' },
  statRow:    { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #E4EDE8', fontSize:12 },
  modalBtns:  { display:'flex', gap:8, marginTop:20 },
  btnClose:   { flex:1, padding:10, borderRadius:10, border:'1px solid #E4EDE8', background:'#F0F4F0', color:'#7A8F89', fontSize:13, cursor:'pointer', fontFamily:'inherit' },
  btnBloquear:{ flex:1, padding:10, borderRadius:10, border:'none', background:'#c62828', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  btnActivar: { flex:1, padding:10, borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  btnGuardar: { flex:1, padding:10, borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
};

export default function Tiendas() {
  const [tiendas,      setTiendas]      = useState(TIENDAS_DEMO);
  const [busqueda,     setBusqueda]     = useState('');
  const [filtroPlan,   setFiltroPlan]   = useState('todos');
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [verTienda,    setVerTienda]    = useState(null);
  const [editando,     setEditando]     = useState(null);
  const [form,         setForm]         = useState({});
  const [hayCambios,   setHayCambios]   = useState(false);

  function actualizarForm(campo, valor) {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setHayCambios(true);
  }

  function abrirEditar(tienda) {
    setForm({
      nombre:      tienda.nombre,
      propietario: tienda.propietario,
      email:       tienda.email,
      tel:         tienda.tel,
      plan:        tienda.plan,
      estado:      tienda.estado,
    });
    setHayCambios(false);
    setVerTienda(null);
    setEditando(tienda.id);
  }

  function cerrarEditar() {
    if (hayCambios) {
      if (!window.confirm('Tienes cambios sin guardar. ¿Seguro que quieres cerrar?')) return;
    }
    setHayCambios(false);
    setEditando(null);
  }

  function guardarEdicion() {
    if (!form.nombre.trim())      { alert('Escribe el nombre de la tienda'); return; }
    if (!form.propietario.trim()) { alert('Escribe el nombre del propietario'); return; }
    if (!form.email.trim())       { alert('Escribe el email'); return; }
    if (!form.tel.trim())         { alert('Escribe el teléfono'); return; }

    setTiendas(prev => prev.map(t => t.id === editando ? {
      ...t,
      nombre:      form.nombre,
      propietario: form.propietario,
      email:       form.email,
      tel:         form.tel,
      plan:        form.plan,
      estado:      form.estado,
    } : t));
    setHayCambios(false);
    setEditando(null);
  }

  function confirmarToggle(tienda) {
    const accion = tienda.estado === 'activo' ? 'bloquear' : 'activar';
    if (!window.confirm(`¿Seguro que quieres ${accion} la tienda "${tienda.nombre}"?`)) return;
    setTiendas(prev => prev.map(t => {
      if (t.id !== tienda.id) return t;
      return { ...t, estado: t.estado === 'activo' ? 'bloqueado' : 'activo' };
    }));
    if (verTienda?.id === tienda.id) {
      setVerTienda(prev => ({ ...prev, estado: prev.estado === 'activo' ? 'bloqueado' : 'activo' }));
    }
  }

  const filtradas = tiendas.filter(t => {
    const matchBusq   = t.nombre.toLowerCase().includes(busqueda.toLowerCase()) || t.subdominio.toLowerCase().includes(busqueda.toLowerCase());
    const matchPlan   = filtroPlan   === 'todos' || t.plan   === filtroPlan;
    const matchEstado = filtroEstado === 'todos' || t.estado === filtroEstado;
    return matchBusq && matchPlan && matchEstado;
  });

  return (
    <div>
      <div style={S.topbar}>
        <h1 style={S.h1}>Tiendas ({tiendas.length})</h1>
      </div>

      <div style={S.filtros}>
        <input style={S.inputBusq} placeholder="🔍 Buscar tienda o subdominio..." value={busqueda} onChange={e => setBusqueda(e.target.value)} />
        <select style={S.sel} value={filtroPlan} onChange={e => setFiltroPlan(e.target.value)}>
          <option value="todos">Todos los planes</option>
          {PLANES_SISTEMA.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
        </select>
        <select style={S.sel} value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
          <option value="todos">Todos los estados</option>
          <option value="activo">Activos</option>
          <option value="bloqueado">Bloqueados</option>
          <option value="prueba">En prueba</option>
        </select>
      </div>

      <div style={S.card}>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>Tienda</th>
              <th style={S.th}>Propietario</th>
              <th style={S.th}>Plan</th>
              <th style={S.th}>Ventas mes</th>
              <th style={S.th}>Próximo pago</th>
              <th style={S.th}>Estado</th>
              <th style={S.th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filtradas.map(t => {
              const plan   = PLAN_BADGE[t.plan]   || PLAN_BADGE.gratis;
              const estado = ESTADO_BADGE[t.estado] || ESTADO_BADGE.activo;
              return (
                <tr key={t.id}>
                  <td style={S.td}>
                    <div style={{ fontWeight:700 }}>{t.nombre}</div>
                    <div style={S.subdom}><span style={S.subdomSpan}>{t.subdominio}</span>.pixventa.com</div>
                  </td>
                  <td style={S.td}>{t.propietario}</td>
                  <td style={S.td}><span style={{ ...S.badge, background:plan.bg, color:plan.color }}>{plan.label}</span></td>
                  <td style={S.td}>${t.ventas.toLocaleString('es-MX', { minimumFractionDigits:2 })}</td>
                  <td style={{ ...S.td, color: t.proximoPago==='Vencido'?'#A32D2D': t.proximoPago.includes('días')?'#633806':'#0D1F1A' }}>{t.proximoPago}</td>
                  <td style={S.td}><span style={{ ...S.badge, background:estado.bg, color:estado.color }}>{estado.label}</span></td>
                  <td style={S.td}>
                    <button style={{ ...S.btn, ...S.btnVer  }} onClick={() => setVerTienda(t)}>👁 Ver</button>
                    <button style={{ ...S.btn, ...S.btnEdit }} onClick={() => abrirEditar(t)}>✏️ Editar</button>
                    {t.estado === 'bloqueado' && <button style={{ ...S.btn, ...S.btnOk   }} onClick={() => confirmarToggle(t)}>✓ Activar</button>}
                    {t.estado === 'activo'    && <button style={{ ...S.btn, ...S.btnRojo }} onClick={() => confirmarToggle(t)}>✕ Bloquear</button>}
                  </td>
                </tr>
              );
            })}
            {filtradas.length === 0 && (
              <tr><td colSpan={7} style={{ ...S.td, textAlign:'center', color:'#7A8F89', padding:32 }}>Sin resultados</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal ver detalle */}
      {verTienda && (
        <div style={S.overlay} onClick={e => e.target === e.currentTarget && setVerTienda(null)}>
          <div style={S.modal}>
            <div style={S.mTitle}>🏪 {verTienda.nombre}</div>
            <div style={S.mGrid}>
              <div style={S.mField}><span style={S.mLbl}>Subdominio</span><span style={{ ...S.mVal, color:'#075E54' }}>{verTienda.subdominio}.pixventa.com</span></div>
              <div style={S.mField}><span style={S.mLbl}>Propietario</span><span style={S.mVal}>{verTienda.propietario}</span></div>
              <div style={S.mField}><span style={S.mLbl}>Email</span><span style={S.mVal}>{verTienda.email}</span></div>
              <div style={S.mField}><span style={S.mLbl}>Teléfono</span><span style={S.mVal}>{verTienda.tel}</span></div>
              <div style={S.mField}><span style={S.mLbl}>Plan</span><span style={{ ...S.badge, ...(PLAN_BADGE[verTienda.plan] || PLAN_BADGE.gratis) }}>{(PLAN_BADGE[verTienda.plan] || PLAN_BADGE.gratis).label}</span></div>
              <div style={S.mField}><span style={S.mLbl}>Estado</span><span style={{ ...S.badge, ...(ESTADO_BADGE[verTienda.estado] || ESTADO_BADGE.activo) }}>{(ESTADO_BADGE[verTienda.estado] || ESTADO_BADGE.activo).label}</span></div>
              <div style={S.mField}><span style={S.mLbl}>Registrado</span><span style={S.mVal}>{verTienda.creado}</span></div>
              <div style={S.mField}><span style={S.mLbl}>Próximo pago</span><span style={{ ...S.mVal, color: verTienda.proximoPago==='Vencido'?'#A32D2D':'#0D1F1A' }}>{verTienda.proximoPago}</span></div>
            </div>
            <div style={S.divider} />
            <div style={S.statRow}><span style={{ color:'#7A8F89' }}>Ventas del mes</span><span style={{ fontWeight:700, color:'#075E54' }}>${verTienda.ventas.toLocaleString('es-MX', { minimumFractionDigits:2 })}</span></div>
            <div style={{ ...S.statRow, borderBottom:'none' }}><span style={{ color:'#7A8F89' }}>Pedidos del mes</span><span style={{ fontWeight:700 }}>{verTienda.pedidos}</span></div>
            <div style={S.modalBtns}>
              <button style={S.btnClose} onClick={() => setVerTienda(null)}>Cerrar</button>
              <button style={{ ...S.btnClose, color:'#075E54', borderColor:'#c8e6c9' }} onClick={() => abrirEditar(verTienda)}>✏️ Editar</button>
              {verTienda.estado === 'bloqueado'
                ? <button style={S.btnActivar}   onClick={() => confirmarToggle(verTienda)}>✓ Activar tienda</button>
                : <button style={S.btnBloquear}  onClick={() => confirmarToggle(verTienda)}>✕ Bloquear tienda</button>
              }
            </div>
          </div>
        </div>
      )}

      {/* Modal editar tienda */}
      {editando && (
        <div style={S.overlay} onClick={e => e.target === e.currentTarget && cerrarEditar()}>
          <div style={S.modal}>
            <div style={S.mTitle}>✏️ Editar tienda</div>
            <div style={S.mGrid}>
              <div style={{ ...S.mField, gridColumn:'1 / -1' }}>
                <label style={S.mLbl}>Nombre de la tienda</label>
                <input style={S.mInput} value={form.nombre} onChange={e => actualizarForm('nombre', e.target.value)} />
              </div>
              <div style={S.mField}>
                <label style={S.mLbl}>Propietario</label>
                <input style={S.mInput} value={form.propietario} onChange={e => actualizarForm('propietario', e.target.value)} />
              </div>
              <div style={S.mField}>
                <label style={S.mLbl}>Teléfono</label>
                <input style={S.mInput} value={form.tel} onChange={e => actualizarForm('tel', e.target.value)} />
              </div>
              <div style={{ ...S.mField, gridColumn:'1 / -1' }}>
                <label style={S.mLbl}>Email</label>
                <input style={S.mInput} value={form.email} onChange={e => actualizarForm('email', e.target.value)} />
              </div>
              <div style={S.mField}>
                <label style={S.mLbl}>Plan</label>
                <select style={S.mSelect} value={form.plan} onChange={e => actualizarForm('plan', e.target.value)}>
                  {PLANES_SISTEMA.map(p => (
                    <option key={p.id} value={p.id}>
                      {p.nombre} {p.precio > 0 ? `— $${p.precio}/mes (${p.comision}% comisión)` : '— Sin costo'}
                    </option>
                  ))}
                </select>
              </div>
              <div style={S.mField}>
                <label style={S.mLbl}>Estado</label>
                <select style={S.mSelect} value={form.estado} onChange={e => actualizarForm('estado', e.target.value)}>
                  <option value="activo">Activo</option>
                  <option value="bloqueado">Bloqueado</option>
                  <option value="prueba">En prueba</option>
                </select>
              </div>
            </div>
            <div style={S.modalBtns}>
              <button style={S.btnClose} onClick={cerrarEditar}>Cancelar</button>
              <button style={S.btnGuardar} onClick={guardarEdicion}>✓ Guardar cambios</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}